import { combineReducers } from 'redux';
import IUserProfileReducer from '../interfaces/reducers/userProfileReducer';
import accountReducer from './accountReducer';
import articleReducer from './articleReducer';
import autocompleteReducer from './autocompleteReducer';
import countriesReducer from './countriesReducer';
import customsReducer from './customsReducer';
import damageReportReducer from './damageReportReducer';
import eventReducer from './eventReducer';
import familyMembersReducer from './familyMembersReducer';
import locationsReducer from './locationsReducer';
import mobizReducer from './mobizReducer';
import modalReducer from './modalReducer';
import navigationReducer from './navigationReducer';
import notificationsReducer from './notificationsReducer';
import pageReducer from './pageReducer';
import paymentReducer from './paymentReducer';
import postCodesReducer from './postCodesReducer';
import postOfficeReducer from './postOfficeReducer';
import postboxesReducer from './postboxesReducer';
import recipientsReducer from './recipientsReducer';
import refundsReducer from './refundsReducer';
import registerShipmentReducer from './registerShipmentReducer';
import searchReducer from './searchReducer';
import sendReceiptReducer from './sendReceiptReducer';
import sharedReducer from './sharedReducer';
import shipmentsReducer from './shipmentsReducer';
import trackShipmentReducer from './trackShipmentReducer';
import userProfileReducer from './userProfileReducer';

export interface IStore {
	sharedReducer: any;
	pageReducer: any;
	postCodesReducer: any;
	damageReportReducer: any;
	navigationReducer: any;
	articleReducer: any;
	eventReducer: any;
	postOfficeReducer: any;
	registerShipmentReducer: any;
	mobizReducer: any;
	shipmentsReducer: any;
	userProfileReducer: IUserProfileReducer;
	postboxesReducer: any;
	trackShipmentReducer: any;
	searchReducer: any;
	autocompleteReducer: any;
	sendReceiptReducer: any;
	countriesReducer: any;
	customsReducer: any;
	modalReducer: any;
	locationsReducer: any;
	familyMembersReducer: any;
	accountReducer: any;
	paymentReducer: any;
	notificationsReducer: any;
	recipientsReducer: any;
	refundsReducer: any;
}

export type RootState = ReturnType<typeof rootReducer>;

const rootReducer = combineReducers({
	sharedReducer,
	pageReducer,
	postCodesReducer,
	damageReportReducer,
	navigationReducer,
	articleReducer,
	eventReducer,
	postOfficeReducer,
	registerShipmentReducer,
	mobizReducer,
	shipmentsReducer,
	userProfileReducer,
	postboxesReducer,
	trackShipmentReducer,
	searchReducer,
	autocompleteReducer,
	sendReceiptReducer,
	countriesReducer,
	customsReducer,
	modalReducer,
	locationsReducer,
	familyMembersReducer,
	accountReducer,
	paymentReducer,
	notificationsReducer,
	recipientsReducer,
	refundsReducer,
});

export default rootReducer;
